var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":""}},[_c('v-spacer'),_c('div',{staticClass:"footer"},[_vm._v("Powered by YODLEE ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }